import { format } from 'date-fns';

import { Filters } from './FiltersContext';

import type { IEvent } from '..';

type FilterKey = keyof Filters;
const paramKeys: Record<FilterKey, string> = {
	selectedEventTypes: 'eventTypes',
	selectedEventTags: 'eventTags',
	selectedEventLocations: 'locations',
	selectedCountries: 'countries',
	selectedStates: 'states',
	selectedCities: 'cities',
};

export const parseQueryParams = (): { searchTerm: string; filters: Filters } => {
	const params = new URLSearchParams(window.location.search);
	const searchTerm = params.get('search') ?? '';

	const filters = (Object.keys(paramKeys) as FilterKey[]).reduce<Filters>(
		(acc, key) => {
			const v = params.get(paramKeys[key]);
			const arr = v && v.trim() ? v.split(',') : [];
			return {
				...acc,
				[key]: arr,
			};
		},
		// initial empty filters
		{
			selectedEventTypes: [],
			selectedEventTags: [],
			selectedEventLocations: [],
			selectedCountries: [],
			selectedStates: [],
			selectedCities: [],
		}
	);

	return { searchTerm, filters };
};

export const updateQueryParams = (searchTerm: string, filters: Filters) => {
	const params = new URLSearchParams();

	if (searchTerm.trim()) params.set('search', searchTerm.trim());

	(Object.entries(paramKeys) as [FilterKey, string][]).forEach(([key, param]) => {
		const vals = filters[key];
		if (Array.isArray(vals) && vals.length) {
			params.set(param, vals.filter((v) => v.trim()).join(','));
		}
	});

	const newSearch = params.toString();
	const base = window.location.pathname;
	window.history.pushState({}, '', newSearch ? `${base}?${newSearch}` : base);
};

export const getMonthKey = (date: Date): string => format(date, 'yyyy-MM');

export const toArray = (value) =>
	Array.isArray(value)
		? value
		: String(value || '')
				.split(',')
				.map((str) => str.trim())
				.filter(Boolean);

export const normalizeEvent = (event: IEvent): IEvent => {
	return {
		...event,
		id: event.UID,
		start: new Date(event.start),
		end: new Date(event.end),
		eventType: toArray(event.eventType),
		tags: toArray(event.tags),
		address: event.address.trim(),
	};
};
